import { PanelType } from '@fluentui/react';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataOperation_CycleOperation } from '../../data/DataOperation_CycleOperation';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';

export class FicheValidationCycleProgramme extends Component {

    static defaultProps = {
        idProgramme: undefined,
        idRegion: undefined,
        idAgence: undefined,
        idCycleOperation: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        cycleOperation: {},
        programme: {},
        datePremiereOperationCommerciale: null,
        dateObtentionPC: null,
        dateObtentionPCPrevue: null,
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheValidationCycleProgramme.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du cycle du programme'
        });

        const { idCycleOperation, idProgramme, idRegion, idAgence } = this.props;

        DataOperation_CycleOperation._chargementCycleOperationPourUnProgramme(idCycleOperation, idProgramme, idRegion, idAgence).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const state = {
                    cycleOperation: objetData[0],
                    programme: objetData[1],
                    datePremiereOperationCommerciale: objetData[2],
                    dateObtentionPC: objetData[3],
                    dateObtentionPCPrevue: objetData[4],
                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, { onActiveBoutonEnregistrer: false }, retourVerif, responseFetch);
        });

    };

    _onVerificationFormulaire = () => {
        const { idCycleOperation } = this.props;
        const item = { ...this.state.programme, idCycleOperation };
        Immocom.fiche()._validationFormulaire(this, 'CycleProgramme', item, 'Modification');
    };

    _onEnregistrement = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du cycle du programme'
        });

        const { idCycleOperation, idProgramme, idRegion, idAgence } = this.props;
        const { programme } = this.state;

        DataOperation_CycleOperation._enregistrementCycleOperationPourUnProgramme(idCycleOperation, idProgramme, idRegion, idAgence, programme).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...this.state }, this.props.onSave);
            else Immocom.onTraitementErreurAvecState(this, { onActiveBoutonEnregistrer: false }, retourVerif, responseFetch);
        });

    };

    _onDismiss = () => {
        this.setState({ ...FicheValidationCycleProgramme.defaultState });
        this.props.onDismiss();
    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onSelectDate = (champs) => (event) => {
        const programme = { ...this.state.programme };
        const newDate = Scriba.date().getChaineISOFromDate(event, true);
        programme[champs] = newDate;

        this.setState(
            { programme: programme },
            this._onVerificationFormulaire
        );
    };

    render = () => {

        const { isOpen } = this.props;
        const { cycleOperation, onActiveBoutonEnregistrer, programme } = this.state;

        const aujourdhui = new Date(Date.now());
        const demain = addDays(aujourdhui, 1);

        let headerText = "Valider le cycle";
        if (!!cycleOperation.libelle) headerText += ` « ${cycleOperation.libelle} »`;

        return <EUIPanel
            headerText={headerText}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSave={this._onEnregistrement}
            type={PanelType.medium}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {!!cycleOperation.descriptif && <div className="zoneDescriptifCycle">{cycleOperation.descriptif}</div>}

            {cycleOperation.idCycleOperation >= 30 &&
                <EUIDatePicker
                    isRequired
                    disabled
                    label="Date perspective"
                    value={programme.datePerspective}
                />
            }

            {cycleOperation.idCycleOperation >= 20 &&
                <EUIDatePicker
                    isRequired
                    label="Date développement"
                    maxDate={aujourdhui}
                    onSelectDate={this._onSelectDate('dateDeveloppement')}
                    value={programme.dateDeveloppement}
                />
            }

            {cycleOperation.idCycleOperation >= 30 &&
                <Fragment>
                    <EUIDatePicker
                        isRequired
                        label="Date accord comité promesse"
                        maxDate={aujourdhui}
                        onSelectDate={this._onSelectDate('dateAccordComitePromesse')}
                        value={programme.dateAccordComitePromesse}
                    />
                    <EUIDatePicker
                        isRequired
                        label="Date signature promesse"
                        maxDate={aujourdhui}
                        onSelectDate={this._onSelectDate('dateSignaturePromesse')}
                        value={programme.dateSignaturePromesse}
                    />
                    <EUIDatePicker
                        isRequired={!programme.dateSignaturePromesseFinValidite}
                        label="Date signature promesse fin de validité prévue"
                        minDate={demain}
                        onSelectDate={this._onSelectDate('dateSignaturePromesseFinValiditePrevue')}
                        value={programme.dateSignaturePromesseFinValiditePrevue}
                    />
                    <EUIDatePicker
                        isRequired={!programme.dateSignaturePromesseFinValiditePrevue}
                        label="Date signature promesse fin de validité"
                        maxDate={aujourdhui}
                        onSelectDate={this._onSelectDate('dateSignaturePromesseFinValidite')}
                        value={programme.dateSignaturePromesseFinValidite}
                    />
                    <HintWrapper
                        content={<span>Plus petite date prévisionnelle de commercialisation parmi toutes les opérations du programme</span>}
                        verticalAlign={HintVerticalPosition.bottom}
                        verticalOffset={5}
                    >
                        <EUIDatePicker
                            disabled
                            label="Date lancement commercialisation prévue"
                            value={this.state.datePremiereOperationCommerciale}
                        />
                    </HintWrapper>
                </Fragment>
            }

            {cycleOperation.idCycleOperation >= 40 &&
                <EUIDatePicker
                    isRequired
                    label="Date accord comité achat terrain"
                    maxDate={aujourdhui}
                    onSelectDate={this._onSelectDate('dateAccordComiteAchatTerrain')}
                    value={programme.dateAccordComiteAchatTerrain}
                />
            }

            {cycleOperation.idCycleOperation >= 40 &&
                <EUIDatePicker
                    isRequired
                    label="Date achat terrain prévue"
                    minDate={demain}
                    onSelectDate={this._onSelectDate('dateAchatTerrainPrevue')}
                    value={programme.dateAchatTerrainPrevue}
                />
            }

            {cycleOperation.idCycleOperation >= 40 &&
                <EUIDatePicker
                    isRequired
                    label="Date achat terrain"
                    maxDate={aujourdhui}
                    onSelectDate={this._onSelectDate('dateAchatTerrain')}
                    value={programme.dateAchatTerrain}
                />
            }

            {cycleOperation.idCycleOperation >= 40 &&
                <EUIDatePicker
                    disabled
                    isRequired={!this.state.dateObtentionPC}
                    label="Date obtention PC prévue"
                    value={this.state.dateObtentionPCPrevue}
                />
            }

            {/* KP - 14/06/2023 - 2387
            {cycleOperation.idCycleOperation >= 40 &&
                <EUIDatePicker
                    disabled
                    isRequired={(cycleOperation.idCycleOperation === 40 && !this.state.dateObtentionPCPrevue) || cycleOperation.idCycleOperation > 40}
                    label="Date obtention PC"
                    value={this.state.dateObtentionPC}
                />
            }
            */}
        </EUIPanel>;

    };

};